import React from "react";
import { WrappedLink } from "@components/navigation";
import HeaderItemWrapper from "./HeaderItemWrapper";
import classnames from "classnames";
import { getLoginReturnUrl } from "@utils/auth";
import { THEME_SETTINGS } from "@theme-settings";

export default function HeaderLoginButton({
	isRegistrationButtonHidden,
	text,
}: {
	isRegistrationButtonHidden: boolean;
	text: string;
}) {
	classnames;
	return (
		<HeaderItemWrapper>
			<WrappedLink
				to={getLoginReturnUrl()}
				className={classnames(
					"header__btn header__btn--login btn btn--sml",
					{
						"btn--primary": isRegistrationButtonHidden,
						"btn--secondary--inverted": !isRegistrationButtonHidden,
						"btn--icon":
							THEME_SETTINGS.licensingIcons.includes("ggl"),
					}
				)}
			>
				{text}

				{THEME_SETTINGS.licensingIcons.includes("ggl") && (
					<i className="header__btn__icon u-icon u-icon--base u-icon--legal u-icon--age-restriction u-color--core--snow" />
				)}
			</WrappedLink>
		</HeaderItemWrapper>
	);
}
